(function( $ ) {
    
    let attachEnquireParams = function() {
        $('body').on('click', ".button--enquire", function(e) {
            e.preventDefault();

            var title = $(this).data('product-title');
            var price = $(this).data('product-price');

            sessionStorage.setItem('enquire_product_title', title);
            sessionStorage.setItem('enquire_product_price', price);

            window.location.href = $(this).attr('href');

            console.log('Title:', title);
            console.log('Price:', price);
        });
    }

    let populateContactForm = function() {
        if ($('body').hasClass('template-page-contact') || window.location.pathname.includes('/contact')) {
            var productTitle = sessionStorage.getItem('enquire_product_title');
            var productPrice = sessionStorage.getItem('enquire_product_price');

            if (productTitle || productPrice) {

                console.log('Title:', productTitle);
                console.log('Price:', productPrice);

                $('#ContactForm-product-title').val(productTitle);
                $('#ContactForm-product-price').val(productPrice);

                $('#ContactForm-product-title, #ContactForm-product-price').attr('type', 'hidden').show();
            } else {
                $('#ContactForm-product-title, #ContactForm-product-price').remove();
            }
        }
    }

    let enquireButton = function() {
        
        $('body').on('click', ".button--enquire", function(e) {
            e.preventDefault();

            $('body').addClass('enquire-form__is-active')
            $(this).hide();
            $('.product__contact-form').slideDown('slow');
        });

    }


    const $images = $(".custom-process__images");
    const $texts = $(".custom-process__text");

    function isInViewport(el) {
        const rect = el.getBoundingClientRect();
        return (
            rect.top < (window.innerHeight * 0.6) &&
            rect.bottom > (window.innerHeight * 0.4)
        );
    }

    function updateActiveState() {
        let activeFound = false;

        $images.each(function () {
            const $img = $(this);
            const $targetText = $("#" + $img.data("id"));

            if (isInViewport(this) && !activeFound) {
                $images.removeClass("active");
                $texts.removeClass("active");

                $img.addClass("active");
                $targetText.addClass("active");

                activeFound = true;
            }
        });
    }

    let $originalParent = null;
    let $wrapper = null;

    function handleInstagramResize() {
        const $text = $('.gfa-content__text');
        const $button = $('.gfa-content__button-container');
        const $target = $('.gfa-widget .gfa-media:first');
        const width = $(window).width();

        if (!$wrapper) {
            if ($text.length && $button.length) {
                $text.add($button).wrapAll('<div class="gfa-content__wrapper" />');
                $wrapper = $('.gfa-content__wrapper');
                $originalParent = $wrapper.parent();
            }
        }

        if (!$wrapper || !$target.length) return;

        if (width >= 768) {
            if (!$('.gfa-content__wrapper').prev('.gfa-media:first').length) {
                $wrapper.insertBefore($target);
            }
        } else {
            if ($originalParent && !$originalParent.find('.gfa-content__wrapper').length) {
                $originalParent.append($wrapper.detach());
            }
        }
    }

    handleInstagramResize();
    setTimeout(handleInstagramResize, 200);
    $(window).on('resize', handleInstagramResize);
    $(window).on('load', handleInstagramResize);


    $(document).ready(function() {

        // Init functions
        // attachEnquireParams();
        // populateContactForm();
        updateActiveState();
        enquireButton();
    });

    $(window).on("scroll resize", function () {
        updateActiveState();
    });
    
})( jQuery );